import React from 'react';
import { BoxGeometry, LineBasicMaterial, Vector2, WireframeGeometry } from 'three';

import { Direction2D, Point2D } from '@paragon/contract-library';

const bracingWidth = 3.5;
const bracingThickness = 1.5;
const bracingGeometry = new WireframeGeometry(new BoxGeometry(bracingWidth, bracingThickness, 0, 1, 1, 0));

const defaultColor = 0xff73b0;
const defaultMaterial = new LineBasicMaterial({ color: defaultColor });

export const BracingVisual = ({ point, direction }: { point: Point2D; direction: Direction2D }) => {
  const positionOnEdgeOfMember = new Vector2(point.x, point.y);
  const outwardDirection = new Vector2(direction.x, direction.y);
  const { x, y } = positionOnEdgeOfMember.addScaledVector(outwardDirection, bracingThickness / 2);
  const rotation = Math.atan2(direction.y, direction.x) + Math.PI / 2;

  return (
    <lineSegments position={[x, y, 0]} rotation={[0, 0, rotation]}>
      <primitive attach="geometry" object={bracingGeometry} />
      <primitive attach="material" object={defaultMaterial} />
    </lineSegments>
  );
};
